import { ListItemButton, ListItemIcon, styled } from '@mui/material';

import { SidebarNavItemIconProps } from '../../props';

export const StyledListItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => !['level', 'isSideBarOpen', 'iconSelectedColor'].includes(prop as string),
})<{
  level: number;
  isSideBarOpen: boolean;
  iconSelectedColor: string;
}>`
  z-index: 1201;
  padding: ${({ level }) => (level === 1 ? '.5rem 1.5rem' : '.25rem 1rem')};
  border-radius: 4px;
  min-height: ${({ isSideBarOpen }) => (isSideBarOpen ? '48px' : '40px')};

  & :link {
    background-color: #ffffff14;
  }

  &.Mui-selected:hover {
    background-color: #274f8a0a;
  }

  &.Mui-selected {
    background-color: #274f8a;
  }

  &.MuiListItemButton-root:hover {
    background-color: #274f8a60;
  }

  &.Mui-disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  /* Responsive adjustments for collapsed sidebar */
  ${({ isSideBarOpen }) =>
    !isSideBarOpen &&
    `
    justify-content: center;
    padding: .5rem;
    min-width: 48px;
    width: 48px;
    margin: 0 auto;
    
    /* Center the icon when sidebar is closed */
    .MuiListItemIcon-root {
      margin: 0;
      min-width: 24px;
      justify-content: center;
    }
  `}
`;

export const StyledListItemIcon = styled(ListItemIcon, {
  shouldForwardProp: (prop) => !['level', 'iconSelectedColor', 'activeModule'].includes(prop as string),
})<Omit<SidebarNavItemIconProps, 'theme'>>(({ level, iconSelectedColor }) => ({
  minWidth: level === 1 ? 36 : 18,
  color: iconSelectedColor,
}));
